import { type FC } from "react";
import { Spinner } from "flowbite-react";
import { Dialog, Button } from "@components";
import { textHeading, textMuted, Stack } from "@design-system";

export interface DialogNotifyProp {
  show: boolean;
  isLoading: boolean;
  hideButtons?: boolean;
  buttonConfirmColor?: string;
  buttonConfirmText?: string;
  buttonConfirmPrependIcon?: React.ReactNode;
  buttonCloseText?: string;
  buttonClosePrependIcon?: React.ReactNode;
  icon?: React.ReactNode;
  iconBackground?: string;
  title: string;
  text?: string;
  size?: string;
  content?: React.ReactNode;
  toggleModal: () => void;
  confirmButton: (data?: any) => void;
}

export const DialogNotify: FC<DialogNotifyProp> = (props) => {
  const dialogContent = (
    <Stack gap={4} align="center" className="justify-between">
      {props.icon}
      <p className={`text-xl ${textHeading}`}>{props.title}</p>
      {props.text && (
        <p className={`text-md ${textMuted} text-center`}>{props.text}</p>
      )}
      {props.content && <div>{props.content}</div>}
      <div className="flex gap-4">
        {props.buttonCloseText && (
          <Button color="gray" onClick={() => props.toggleModal()}>
            {props.buttonClosePrependIcon}
            {props.buttonCloseText}
          </Button>
        )}
        {
          !props.hideButtons &&
            props.buttonConfirmText &&
            (!props.isLoading ? (
              <Button
                onClick={() => props.confirmButton()}
                color={
                  props.buttonConfirmColor
                    ? props.buttonConfirmColor
                    : "primary"
                }
                type="submit"
              >
                {props.buttonConfirmPrependIcon}
                {props.buttonConfirmText}
              </Button>
            ) : (
              <Button
                color={
                  props.buttonConfirmColor
                    ? props.buttonConfirmColor
                    : "primary"
                }
              >
                <Spinner size={"sm"} />
              </Button>
            ))

          // <Button
          //   onClick={() => props.confirmButton()}
          //   color={
          //     props.buttonConfirmColor ? props.buttonConfirmColor : "primary"
          //   }
          //   type="submit"
          // >
          //   {props.buttonConfirmPrependIcon}
          //   {props.buttonConfirmText}
          // </Button>
        }
      </div>
    </Stack>
  );

  return (
    <Dialog
      size={props.size ?? "xl"}
      denseHeader
      dismissible
      content={dialogContent}
      show={props.show}
      toggleModal={props.toggleModal}
      hideButtons={true}
    />
  );
};
